export default __webpack_public_path__ + "static/media/check.fb0537c6.svg";